<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare
        class="loading-position animated fadeIn"
        size="60px"
      ></RotateSquare>
    </div>
    <form v-else @submit="ValidarForm">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">Formulário Dinâmico</strong>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <small>Campos com * são de preenchimento obrigatório</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-8 col-lg-8 col-xl-6">
                  <div class="form-group">
                    <label for>* Título</label>
                    <input
                      v-model="viewModel.title"
                      class="form-control"
                      type="text"
                      placeholder="Digite o título da pergunta"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>* Ordem</label>
                    <input
                      v-model.number="viewModel.order"
                      class="form-control"
                      type="number"
                      min="1"
                      placeholder="Ordem"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for="">* Tipo de Pergunta</label>
                    <b-form-select
                      v-model="viewModel.questionType"
                      :options="tiposOpcoes"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for="">* Contexto</label>
                    <b-form-select
                      v-model="viewModel.isGaau"
                      :options="contextoOpcoes"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div
                  class="col-sm-6 col-md-2 col-lg-2 col-xl-1"
                  title="Informa se a pergunta é de preenchimento obrigatório."
                >
                  <label for>Obrigatório</label>
                  <b-form-checkbox
                    v-model="viewModel.isRequired"
                    name="check-obrigatorio"
                    switch
                  >
                    Sim
                  </b-form-checkbox>
                </div>
              </div>

              <div v-if="temOpcoes" class="row mt-3">
                <div class="col-sm-12">
                  <div class="card border">
                    <header class="card-header">
                      <div class="d-flex">
                        <strong class="align-self-center">Opções de Resposta</strong>
                        <b-button
                          class="ml-auto btn-sm"
                          variant="primary"
                          type="button"
                          @click="AdicionarOpcao"
                        >
                          <i class="fa fa-plus"></i> Adicionar Opção
                        </b-button>
                      </div>
                    </header>
                    <div class="card-body">
                      <div
                        v-for="(opcao, index) in viewModel.options"
                        :key="index"
                        class="row align-items-center mb-2"
                      >
                        <div class="col-sm-1 col-md-1">
                          <input
                            v-model.number="opcao.order"
                            class="form-control"
                            type="number"
                            min="1"
                            placeholder="Ordem"
                            required
                          />
                        </div>
                        <div class="col-sm-9 col-md-9">
                          <input
                            v-model="opcao.label"
                            class="form-control"
                            type="text"
                            placeholder="Digite a opção"
                            required
                          />
                        </div>
                        <div class="col-sm-2 col-md-2">
                          <b-button
                            variant="danger"
                            size="sm"
                            type="button"
                            @click="RemoverOpcao(index)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </b-button>
                        </div>
                      </div>
                      <p v-if="viewModel.options.length === 0" class="text-muted">
                        Nenhuma opção adicionada. Clique em "Adicionar Opção" para incluir.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn-toolbar mb-3 ml-3" role="toolbar">
              <div class="btn-group" role="group">
                <button class="btn btn-success mr-2" type="submit">
                  Salvar
                </button>
              </div>
              <div class="btn-group" role="group">
                <button
                  class="btn btn-secondary"
                  type="reset"
                  @click="$router.go(-1)"
                >
                  Voltar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import DynamicFormService from "../../servico/DynamicFormService";
import QuestionTypeEnum from "../../enums/QuestionTypeEnum";

const TIPOS_COM_OPCOES = [
  QuestionTypeEnum.SingleChoice,
  QuestionTypeEnum.MultipleChoice,
  QuestionTypeEnum.Dropdown
];

export default {
  name: "NovoDynamicForm",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      tiposOpcoes: [
        { value: null, text: "Selecione o tipo" },
        { value: QuestionTypeEnum.ShortText, text: "Texto Curto" },
        { value: QuestionTypeEnum.LongText, text: "Texto Longo" },
        { value: QuestionTypeEnum.SingleChoice, text: "Escolha Única" },
        { value: QuestionTypeEnum.MultipleChoice, text: "Múltipla Escolha" },
        { value: QuestionTypeEnum.Dropdown, text: "Lista Suspensa" },
        { value: QuestionTypeEnum.Scale, text: "Escala" },
        { value: QuestionTypeEnum.Date, text: "Data" },
        { value: QuestionTypeEnum.Number, text: "Número" },
        { value: QuestionTypeEnum.Email, text: "E-mail" }
      ],
      contextoOpcoes: [
        { value: true, text: "Gaau" },
        { value: false, text: "Inventário" }
      ],
      viewModel: {
        id: this.$store.getters.emptyGuid,
        title: "",
        order: 1,
        questionType: null,
        isRequired: false,
        isGaau: true,
        options: []
      }
    };
  },
  computed: {
    temOpcoes() {
      return TIPOS_COM_OPCOES.includes(this.viewModel.questionType);
    }
  },
  watch: {
    "viewModel.questionType": function (novoTipo) {
      if (!TIPOS_COM_OPCOES.includes(novoTipo)) {
        this.viewModel.options = [];
      }
    }
  },
  created() {
    let id = this.$route.params.id;
    if (id) this.Obter(id);
  },
  methods: {
    ValidarForm(evt) {
      evt.preventDefault();
      if (this.viewModel.id !== this.$store.getters.emptyGuid) this.Editar();
      else this.Novo();
    },
    AdicionarOpcao() {
      this.viewModel.options.push({
        id: null,
        label: "",
        order: this.viewModel.options.length + 1,
        value: null
      });
    },
    RemoverOpcao(index) {
      this.viewModel.options.splice(index, 1);
    },
    Obter(id) {
      this.loading = true;

      DynamicFormService.Obter(id)
        .then((resposta) => {
          this.loading = false;
          this.viewModel = resposta.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    Novo() {
      this.loading = true;

      const payload = Object.assign({}, this.viewModel);
      if (!this.temOpcoes) payload.options = [];

      DynamicFormService.Novo(payload)
        .then(() => {
          this.loading = false;
          this.$router.push("/formulario-dinamico");
          this.$notify({
            data: ["Formulário dinâmico cadastrado com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    Editar() {
      this.loading = true;

      const payload = Object.assign({}, this.viewModel);
      if (!this.temOpcoes) payload.options = [];

      DynamicFormService.Editar(payload)
        .then(() => {
          this.loading = false;
          this.$router.push("/formulario-dinamico");
          this.$notify({
            data: ["Formulário dinâmico editado com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
